// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-sablony-clanek-js": () => import("/opt/build/repo/src/sablony/clanek.js" /* webpackChunkName: "component---src-sablony-clanek-js" */),
  "component---src-sablony-blogpaged-js": () => import("/opt/build/repo/src/sablony/blogpaged.js" /* webpackChunkName: "component---src-sablony-blogpaged-js" */),
  "component---src-sablony-stranka-js": () => import("/opt/build/repo/src/sablony/stranka.js" /* webpackChunkName: "component---src-sablony-stranka-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

